module.exports = __webpack_public_path__ + "img/icon_design_on.a0bd758e.svg";